import gql from 'graphql-tag';
import FieldsTimeslotKind from 'graphql/fields/FieldsTimeslotKind'
import FieldsTimeslotKindLimitation from 'graphql/fields/FieldsTimeslotKindLimitation'

export default gql(`
	query timeslot_kind_limitation( $timeslot_kind_guid: String! ) {
		timeslot_kind( guid: $timeslot_kind_guid ) {
			${ FieldsTimeslotKind }
			
			limitation {
				${ FieldsTimeslotKindLimitation }
			}
		}
	}
`);

